import React from "react";
import { Box, Typography } from "@mui/material";

const CabecalhoTabela = () => {
  return (
    <Box
      sx={{
        display: { xs: "none", md: "flex" }, // Oculta em mobile
        flexDirection: "row",
        alignItems: "center",
        p: 2,
        bgcolor: "#f8f9fa",
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        borderBottom: "2px solid #e0e0e0",
      }}
    >
      <Box sx={{ flex: "3", px: 0.5 }}>
        <Typography variant="subtitle2" fontWeight="600" color="text.secondary">
          Produto
        </Typography>
      </Box>

      <Box sx={{ flex: "1.5", px: 0.5 }}>
        <Typography variant="subtitle2" fontWeight="600" color="text.secondary">
          Cód. Fornecedor
        </Typography>
      </Box>

      <Box sx={{ flex: "0.8", px: 0.5 }}>
        <Typography variant="subtitle2" fontWeight="600" color="text.secondary">
          UN
        </Typography>
      </Box>

      <Box sx={{ flex: "1", px: 0.5, textAlign: "center" }}>
        <Typography variant="subtitle2" fontWeight="600" color="text.secondary">
          Qtde
        </Typography>
      </Box>

      <Box sx={{ flex: "1.5", px: 0.5 }}>
        <Typography variant="subtitle2" fontWeight="600" color="text.secondary">
          Preço Unit.
        </Typography>
      </Box>

      <Box sx={{ flex: "1", px: 0.5, textAlign: "center" }}>
        <Typography variant="subtitle2" fontWeight="600" color="text.secondary">
          IPI %
        </Typography>
      </Box>

      <Box sx={{ flex: "2", px: 0.5 }}>
        <Typography variant="subtitle2" fontWeight="600" color="text.secondary">
          Total
        </Typography>
      </Box>

      <Box sx={{ flex: "0.5", px: 0.5 }}>
        <Typography variant="subtitle2" fontWeight="600" color="text.secondary">
          Ação
        </Typography>
      </Box>
    </Box>
  );
};

export default CabecalhoTabela;
